import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { formatValue } from '../utils';

interface FieldRowProps {
  label: string;
  value: any;
  format?: 'price';
}

const FieldRow: React.FC<FieldRowProps> = ({ label, value, format }) => (
  <Box
    sx={{
      display: 'flex',
      py: 2,
      gap: 2,
    }}
  >
    <Grid
      container
      spacing={2}
      sx={{
        width: 1,
      }}
    >
      <Grid
        size={{
          xs: 6,
          md: 'auto',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            alignItems: 'center',
            color: 'text.primary',
            display: 'flex',
            fontWeight: 600,
            height: 1,
            justifyContent: 'flex-start',
            minWidth: { xs: 'auto', md: 300 },
          }}
        >
          {label}:
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 6,
          md: 'auto',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            alignItems: 'center',
            color: 'text.secondary',
            display: 'flex',
            height: 1,
            justifyContent: 'flex-end',
            wordBreak: 'break-word',
          }}
        >
          {formatValue(value, format)}
        </Typography>
      </Grid>
    </Grid>
  </Box>
);

export default React.memo(FieldRow);
